import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findForeignerPersonals = (headers, params) => {
    let query = buildQuery(params, ["email", "passportNo", "fullName"]);
    if (params.filters.idNumber.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    if (params.filters.passportNo.value) {
        query += `&passportNo=${params.filters.passportNo.value?.trim()}`;
    }
    if (params.filters.fullName.value) {
        query += `&fullName=${params.filters.fullName.value?.trim().toLowerCase()}`;
    }
    if (params.filters.birthDay.value) {
        query += `&birthDay=${formatDate(params.filters.birthDay.value)}`;
    }
    if (params.filters.email.value) {
        query += `&email=${params.filters.email.value}`;
    }
    if (params.filters.phoneNumber.value) {
        query += `&phoneNumber=${params.filters.phoneNumber.value.trim()}`;
    }
    if (params.filters.nationalityId.value) {
        query += `&nationalityId=${params.filters.nationalityId.value}`;
    }
    if (params.filters.toDate?.value) {
        query += `&toDate=${params.filters.toDate.value}`;
    }
    if (params.filters.fromDate?.value) {
        query += `&fromDate=${params.filters.fromDate.value}`;
    }
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/foreigner/personal/list${query}`, {
        headers,
    });
};

export const findForeignerPersonalPassport = (headers, idNumber, passportNo) => {
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/foreigner/personal/passport?idNumber=${idNumber}&passportNo=${passportNo}`, {
        headers,
    });
};

export const findHistoryForeignerPersonal = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/foreigner/personal/history/${id}`, {
        headers,
    });
};
